import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, ComparisonDataRequest } from '../../../../../core/pages/shared/models';
import { ApiResponseBuilder } from '../../../../../core/pages/shared/providers';
import { HttpService } from "../../../../shared/providers/httpService";
import { BaseController } from '../../../shared/providers/baseController';


@Injectable()
export class ComparisonDataController extends BaseController {

  public url = 'api/comparison';

  constructor(
    @Inject(HttpService) public httpService: HttpService,
    public apiResponseBuilder: ApiResponseBuilder
  ) {
    super(httpService, apiResponseBuilder);
  }

  public getComparisonData(requestModel: ComparisonDataRequest): Observable<ApiResponse> {
    return this.httpService.get(this.url, requestModel).pipe(this.buildResponseObject);
  }

  public buildResponseObject = map((response, index) => this.apiResponseBuilder.build(response));

  public getControllerUrl(): string {
    return this.url;
  }

}